/** @format */

import {AccountsKpiName} from 'graphql/generated/types';

import {safeDivide, roundFloatNumber} from 'helpers/numberHelpers';

import {CampaignStatFromQuery} from '../types';

const calcKpiValue = (stats: CampaignStatFromQuery, key: AccountsKpiName): number => {
  switch (key) {
    case 'DRR': {
      const float = safeDivide(stats.spent, stats.revenue) * 100;
      return roundFloatNumber(float, 1);
    }
    case 'CPL': {
      const float = safeDivide(stats.spent, stats.conversions);
      return roundFloatNumber(float, 0);
    }
    case 'VTR':
      return stats.videoCompleteRate;
    case 'REVENUE':
      return stats.revenue;
    case 'REACH':
      return stats.reach;
    case 'AVG_VIDEO_COMPLETE_COST':
      return stats.avgVideoCompleteCost;
    case 'ER': {
      const newEngagement = stats.likes + stats.comments + stats.shares;
      const quotient = safeDivide(newEngagement, stats.reach);
      return roundFloatNumber(quotient * 100, 1);
    }
    case 'ROMI': {
      const float = safeDivide(stats.revenue, stats.spent) * 100;
      return roundFloatNumber(float, 1);
    }
    case 'IMPRESSIONS':
      return stats.impressions;
    case 'CPC': {
      const float = safeDivide(stats.spent, stats.clicks);
      return roundFloatNumber(float, 0);
    }
    case 'CLICKS':
      return stats.clicks;
    case 'CONVERSIONS':
      return stats.conversions;
    case 'CPM': {
      const float = safeDivide(stats.spent, stats.impressions) * 1000;
      return roundFloatNumber(float, 1);
    }
    default:
      return 0;
  }
};

export {calcKpiValue};
